import classNames from 'classnames'
import moment from 'moment'

import { PortalNoteModal } from '@apps-common/apps/portal/pages/units/pages/manage/pages/notes/components'
import { ImageComponent } from '@apps-common/components/common'
import { ModalButton } from '@apps-common/components/modals'
import { commonIcons } from '@apps-common/config/icons'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'
import { IPortalNoteModel } from '@apps-common/types/portal/portal-note'

interface IProps {
  note: IPortalNoteModel
  classes?: string
}

export const NoteItemCard: React.FC<IProps> = ({ note, classes }) => {
  const { portalNoteId, entityId, noteImage1, noteContent, pinned, dateEdited } = note

  return (
    <div className='w-full'>
      <ModalButton
        component={PortalNoteModal}
        componentProps={{
          entityId,
          noteId: portalNoteId
        }}
        classes={classNames(
          'relative pt-4 sm:pt-3.5 px-4 py-3.5 bg-surface border border-border rounded-[30px] text-[0.8em] leading-[1.4em] sm:text-[0.95em] jost-light flex flex-col gap-[10px] w-full hover:!opacity-90',
          classes
        )}
        enterAnimation={modalSlideUpEnterAnimation}
        leaveAnimation={modalSlideUpLeaveAnimation}
      >
        {pinned && (
          <div className='absolute top-[-7.5px] left-[-7.5px] flex items-center justify-between w-full gap-[5px]'>
            <div className='w-[30px] h-[30px] rounded-full action-success overflow-hidden flex items-center justify-center'>
              <commonIcons.pinUnit />
            </div>
          </div>
        )}

        <div className='flex flex-col w-full gap-[5px]'>
          <div className='grow w-full flex items-start justify-between gap-[7px] sm:gap-[5px]'>
            <div className='flex items-center justify-center w-[50px] min-w-[50px] h-[73px] rounded-[15px] lg:w-[70px] lg:min-w-[70px] lg:h-[70px] lg:rounded-[25px] overflow-hidden bg-surface-2 border border-border p-[2px]'>
              <ImageComponent
                src={noteImage1}
                alt='Note image'
                errorIconClasses='opacity-40 flex items-center justify-center w-[60%] h-[60%]'
                imageClasses='object-cover object-center min-w-full min-h-full rounded-[15px] lg:rounded-[25px]'
                errorComponent={
                  <div>
                    <commonIcons.add className='text-[1.5rem] mx-auto' />
                    <div className='text-[0.8rem]'>Image</div>
                  </div>
                }
              />
            </div>
            <div className='grow relative overflow-hidden flex flex-col h-[73px] items-between justify-center gap-[5px] text-left bg-surface border border-border text-text px-[15px] pb-[10px] pt-[25px] rounded-[20px] min-h-[60px] sm:min-h-[70px]'>
              <div className='absolute top-[0px] right-[0px] px-[15px] text-[0.7rem] jost-medium rounded-bl-[15px] bg-surface-2 inline-block ml-auto'>
                {moment(dateEdited).format('Do MMM YY')}
              </div>
              <div className='text-ellipsis line-clamp-2'>{noteContent}</div>
            </div>
          </div>
        </div>
      </ModalButton>
    </div>
  )
}
